// middleware/redirects.js
import {
  CITYLESS_CATALOG_DEFAULT_CITY,
  CITYLESS_CATALOG_PATH_PATTERN,
  SEO_REDIRECTS,
} from "../common/seo/seo-policy";
import { isSpamProfilePath } from "../common/seo/spam-profile";

const INDEX_PATHS = [
  "/index.asp",
  "/index.aspx",
  "/index.htm",
  "/index.html",
  "/index.php",
];

export default function (req, res, next) {
  const host = req.headers.host || "";
  const baseUrl = process.env.BASE_URL_EMIRATE;
  const [requestPath, rawQuery] = req.url.split("?");
  const queryString = rawQuery ? `?${rawQuery}` : "";
  const normalizedPath =
    requestPath.length > 1 ? requestPath.replace(/\/$/, "") : requestPath;

  if (INDEX_PATHS.includes(normalizedPath.toLowerCase())) {
    res.writeHead(301, { Location: baseUrl });
    res.end();
    return;
  }

  if (host.startsWith("www.")) {
    res.writeHead(301, { Location: `${baseUrl}${req.url}` });
    res.end();
    return;
  }

  if (isSpamProfilePath(normalizedPath)) {
    res.writeHead(410, { "Content-Type": "text/plain; charset=utf-8" });
    res.end("Gone");
    return;
  }

  if (SEO_REDIRECTS[normalizedPath]) {
    res.writeHead(301, {
      Location: `${baseUrl}${SEO_REDIRECTS[normalizedPath]}${queryString}`,
    });
    res.end();
    return;
  }

  const citylessMatch = normalizedPath.match(CITYLESS_CATALOG_PATH_PATTERN);
  if (citylessMatch) {
    const [, pathGender, slug] = citylessMatch;
    const gender = pathGender === "shemale" ? "transgender" : pathGender;
    res.writeHead(301, {
      Location: `${baseUrl}/${CITYLESS_CATALOG_DEFAULT_CITY}/${gender}/${slug}${queryString}`,
    });
    res.end();
    return;
  }

  if (normalizedPath == "/shemale" || normalizedPath.startsWith("/shemale/")) {
    const targetPath = normalizedPath.replace(
      /^\/shemale(?=\/|$)/,
      "/transgender"
    );
    res.writeHead(301, { Location: `${baseUrl}${targetPath}${queryString}` });
    res.end();
    return;
  }

  next();
}
